import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { api } from "../lib/api";
import { Seo } from "../components/site/Seo";

export default function BlogPage() {
  const [articles, setArticles] = useState(null);

  useEffect(() => {
    api.get("/articles").then((r) => setArticles(r.data)).catch(() => setArticles([]));
  }, []);

  return (
    <main className="bg-white min-h-[60vh]" data-testid="blog-page">
      <Seo
        title="Consejos de acuarismo — Blog AZOO Costa Rica"
        description="Consejos prácticos de acuarismo: calidad del agua, alimentación natural y mantenimiento de acuarios. Blog de AZOO Costa Rica."
      />
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-16">
        <div className="max-w-2xl mb-12">
          <span className="text-xs font-bold uppercase tracking-widest text-brand-700">Consejos</span>
          <h1 className="text-3xl sm:text-4xl font-black text-zinc-950 mt-2">Blog de acuarismo</h1>
          <p className="text-sm text-zinc-600 mt-3">Guías prácticas para mantener tu acuario saludable, escritas por el equipo de AZOO Costa Rica.</p>
        </div>

        {!articles && <p className="text-sm text-zinc-500" data-testid="blog-loading">Cargando artículos…</p>}
        {articles && articles.length === 0 && (
          <p className="text-sm text-zinc-500" data-testid="blog-empty">Aún no hay artículos publicados.</p>
        )}

        <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
          {(articles || []).map((a) => (
            <Link key={a.slug} to={`/blog/${a.slug}`} className="space-y-3 group" data-testid={`blog-card-${a.slug}`}>
              <div className="aspect-video rounded-xl overflow-hidden bg-zinc-100">
                {a.image && <img src={a.image} alt={a.title} loading="lazy" className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500" />}
              </div>
              <h2 className="text-base font-bold text-zinc-950 group-hover:text-brand-700 transition-colors leading-snug">{a.title}</h2>
              <p className="text-xs text-zinc-600 leading-relaxed">{a.excerpt}</p>
            </Link>
          ))}
        </div>
      </div>
    </main>
  );
}
